/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Изображение знака (только ТЗ)
 * @export
 * @interface GetRegistry200ResponseDataImage
 */
export interface GetRegistry200ResponseDataImage {
  /**
   *
   * @type {string}
   * @memberof GetRegistry200ResponseDataImage
   */
  fileUrl: string
}

/**
 * Check if a given object implements the GetRegistry200ResponseDataImage interface.
 */
export function instanceOfGetRegistry200ResponseDataImage(
  value: object
): value is GetRegistry200ResponseDataImage {
  if (!('fileUrl' in value) || value['fileUrl'] === undefined) return false
  return true
}

export function GetRegistry200ResponseDataImageFromJSON(
  json: any
): GetRegistry200ResponseDataImage {
  return GetRegistry200ResponseDataImageFromJSONTyped(json, false)
}

export function GetRegistry200ResponseDataImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistry200ResponseDataImage {
  if (json == null) {
    return json
  }
  return {
    fileUrl: json['fileUrl'],
  }
}

export function GetRegistry200ResponseDataImageToJSON(
  value?: GetRegistry200ResponseDataImage | null
): any {
  if (value == null) {
    return value
  }
  return {
    fileUrl: value['fileUrl'],
  }
}
